import { render } from "./SVGCloser.vue?vue&type=template&id=c4edd448"
const script = {}

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__